<template>
    <rect
        data-html="true"
        height="34"
        width="3"
        :x="id * 5"
        y="0"
        :fill="this.statusColour"
        :id="`event-${id}`"
        v-tooltip="vtooltipSettings"
    />
</template>

<script>
import dayjs from 'dayjs'

// lodash components
import forEach from 'lodash/forEach'

export default {
    props: {
        eventDetails: null,
        id: null,
    },
    data() {
        return {
            vtooltipSettings: {
                content: this.details(),
                theme: 'menu',
                placement: 'top',
                delay: 0,
                instantMove: true,
                html: true,
                triggers: ['hover', 'focus', 'touch'],
            },
        }
    },
    methods: {
        details: function () {
            let message = ''

            if (this.eventDetails) {
                message = `<h4>${this.eventDetails.date}</h4>`
                if (this.eventDetails.uptime == 100) {
                    message += `<p>${this.$t('status.eventDetails.nodownTime')}</p>`
                } else {
                    message += `<p>${this.$t('status.eventDetails.uptime')}: ${
                        this.eventDetails.uptime
                    } %</p><div class="container">`

                    forEach(this.eventDetails.incidents, incident => {
                        let outageMsg = this.$t(`status.eventDetails.${incident.priority}`)
                        let minutes = Math.floor(incident.durationSeconds / 60)
                        let seconds = Math.floor(incident.durationSeconds - minutes * 60)
                        let time = dayjs(incident.openTime).format('HH:mm:ss')

                        message += '<div class="outage row">'
                        message += `<div class="col-8" ><i class="fas ${incident.priority} fa-exclamation-triangle"></i>${outageMsg} <span class="time">@${time}</span></div>
                        <div class="col-4" >${minutes} min ${seconds} sec</div>`
                        message += '</div>'
                    })

                    message += '</div>'
                }
            } else {
                message = `<p>${this.$t('status.eventDetails.nodownTime')}</p>`
            }
            return message
        },
    },
    computed: {
        statusColour: function () {
            if (this.eventDetails == null) {
                return '#AAAAAA'
            }
            if (this.eventDetails.uptime === 0) {
                return '#C44031'
            }
            if (this.eventDetails.uptime < 100) {
                return '#b6dd3d'
            }
            return '#6cdb56'
        },
    },
}
</script>
<style lang="scss">
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.monitor {
    svg {
        rect:hover {
            fill: #5e6c84;
            outline: 0;
        }
        rect:active {
            outline: 0;
        }
        rect:focus {
            outline: 0;
        }
    }
}

.v-popper--theme-menu {
    $color: #fff;
    box-shadow: 0px 2px 24px $shadow;
    width: 400px;

    @media screen and (max-width: $bp-medium) {
        width: 100%;
    }

    .outage {
        padding: 10px 0;
        background: #f6f6f6;
        margin-bottom: 5px;
        border-radius: 5px;
    }
    .v-popper__inner {
        background: $color;
        border: 1px solid $color-grey;
        padding: 24px;

        @media screen and (max-width: $bp-medium) {
            padding: 12px;
        }

        div {
            color: #000;
        }

        h4 {
            color: var(--text-offer-example);
            font-size: 0.9rem;
        }
    }

    .v-popper__arrow {
        border-color: $color;
    }
}
</style>
